/*
 * T-02 — PDP "Trust Reassurance" slider (mobile, <=749px).
 * Native rollout of the VWO SL_T02 variant, tracking stripped.
 *
 * The USP card is server-rendered (snippets/pdp-trust-reassurance-usp.liquid). This script
 * injects the trust slider (same 4 badges, carousel form) in the two spots that require it:
 *   - above the sticky ATC bar (.product-sticky-bar-wrap)
 *   - inside the variant drawer, before its CTA (.pdpVariantDrawer .variantBtmCTAWrap)
 * and runs a small manual-advance controller (next arrow + seamless loop). Uses classes,
 * not ids, so the two instances don't collide. pdp-variant-sheet.js is not modified.
 */
(function () {
  'use strict';

  if (window.PdpTrustReassurance) return;
  window.PdpTrustReassurance = true;

  // Mobile only (theme canonical breakpoint). Product gating is handled in Liquid.
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

  var SLIDE_1 =
    '<div class="ptr_slide">' +
      '<div class="ptr_item"><span class="ptr_icon">' +
        '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M4 12h20v20H4z" stroke-width="2.4" stroke-linejoin="round"></path>' +
          '<path d="M24 20h9l7 7v5h-16z" stroke-width="2.4" stroke-linejoin="round"></path>' +
          '<circle cx="13" cy="35" r="4" stroke-width="2.4"></circle>' +
          '<circle cx="34" cy="35" r="4" stroke-width="2.4"></circle>' +
          '<path d="M8 17h9M8 22h6" stroke-width="2.4" stroke-linecap="round"></path>' +
        '</svg>' +
      '</span><span class="ptr_label">Free Delivery &amp;<br>Returns</span></div>' +
      '<span class="ptr_divider"></span>' +
      '<div class="ptr_item"><span class="ptr_icon">' +
        '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M29 6c-9.6 1.2-17 9.4-17 19.4C12 36 20.2 44 30.6 44c6.3 0 11.9-3.1 15.4-7.9-2 .9-4.2 1.4-6.5 1.4-11 0-19.9-8.9-19.9-19.9 0-4.4 1.4-8.4 3.9-11.7-.5.4-1 .8-1.5 1.2z" stroke-width="2.4" stroke-linejoin="round"></path>' +
          '<path d="M39 6l1.4 3.2L44 10.5l-3.6 1.3L39 15l-1.4-3.2-3.6-1.3 3.6-1.3z" stroke-width="2" stroke-linejoin="round"></path>' +
        '</svg>' +
      '</span><span class="ptr_label">100 Night Risk<br>Free Trial</span></div>' +
    '</div>';

  var SLIDE_2 =
    '<div class="ptr_slide">' +
      '<div class="ptr_item"><span class="ptr_icon">' +
        '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M24 5l16 5.5v10.2C40 30.6 33.6 39 24 43 14.4 39 8 30.6 8 20.7V10.5z" stroke-width="2.4" stroke-linejoin="round"></path>' +
          '<path d="M17 23l5 5 9-10" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>' +
      '</span><span class="ptr_label">10 Years Warranty</span></div>' +
      '<span class="ptr_divider"></span>' +
      '<div class="ptr_item"><span class="ptr_icon">' +
        '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<rect x="5" y="12" width="38" height="26" rx="5" stroke-width="2.4"></rect>' +
          '<path d="M5 19h38" stroke-width="2.4"></path>' +
          '<path d="M12 30h9" stroke-width="2.6" stroke-linecap="round"></path>' +
        '</svg>' +
      '</span><span class="ptr_label">No Cost EMI</span></div>' +
    '</div>';

  // Slide 1 duplicated (aria-hidden) so the loop back to the start is seamless.
  var SLIDE_1_DUP = SLIDE_1.replace('<div class="ptr_slide">', '<div class="ptr_slide" aria-hidden="true">');

  var SLIDER_HTML =
    '<div class="ptr_slider_wrap">' +
      '<div class="ptr_bar">' +
        '<span class="ptr_pill">1/2</span>' +
        '<div class="ptr_viewport"><div class="ptr_track">' + SLIDE_1 + SLIDE_2 + SLIDE_1_DUP + '</div></div>' +
        '<button class="ptr_arrow" type="button" aria-label="Next">' +
          '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4l8 8-8 8" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
        '</button>' +
      '</div>' +
    '</div>';

  var TOTAL = 2;

  // Manual-advance controller for one .ptr_slider_wrap instance.
  function initSlider(wrap) {
    if (!wrap || wrap.dataset.ptrInit) return;
    var track = wrap.querySelector('.ptr_track');
    var pill = wrap.querySelector('.ptr_pill');
    var arrow = wrap.querySelector('.ptr_arrow');
    if (!track || !pill || !arrow) return;
    wrap.dataset.ptrInit = '1';

    var index = 0;
    var animating = false;

    function updatePill() { pill.textContent = (index % TOTAL + 1) + '/' + TOTAL; }
    function setArrow(enabled) { arrow.disabled = !enabled; arrow.style.opacity = enabled ? '1' : '0.5'; }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (index === 2) {
        // Jump from the duplicate slide back to the real first slide without animating.
        track.classList.add('ptr_no_transition');
        index = 0;
        track.style.transform = 'translateX(0%)';
        void track.offsetWidth; // force reflow so the no-transition snap applies
        track.classList.remove('ptr_no_transition');
      }
      animating = false;
      setArrow(true);
    });

    arrow.addEventListener('click', function () {
      if (animating) return;
      animating = true;
      setArrow(false);
      index += 1;
      track.style.transform = 'translateX(-' + (index * (100 / 3)) + '%)';
      updatePill();
    });

    updatePill();
  }

  function injectSticky() {
    var wrap = document.querySelector('.product-main-sticky-bar .product-sticky-bar-wrap');
    if (!wrap) return;
    var bar = wrap.closest('.product-main-sticky-bar');
    if (!bar || bar.querySelector('.ptr_slider_wrap')) return;
    wrap.insertAdjacentHTML('beforebegin', SLIDER_HTML);
    initSlider(bar.querySelector('.ptr_slider_wrap'));
  }

  function injectDrawer() {
    var cta = document.querySelector('.pdpVariantDrawer .variantBtmCTAWrap');
    if (!cta) return;
    var drawer = cta.closest('.pdpVariantDrawer');
    if (!drawer || drawer.querySelector('.ptr_slider_wrap')) return;
    cta.insertAdjacentHTML('beforebegin', SLIDER_HTML);
    initSlider(drawer.querySelector('.ptr_slider_wrap'));
  }

  function wireUp() {
    injectSticky();
    injectDrawer();
  }

  function init() {
    wireUp();

    // Re-inject if the sticky bar / drawer is (re)built on a variant-change re-render.
    // One coalesced, idempotent observer on a node that survives the re-render.
    var scope = document.querySelector('product-info') || document.body;
    var scheduled = false;
    var raf = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      raf(function () { scheduled = false; wireUp(); });
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
